export default __webpack_public_path__ + "static/media/profile-placeholder.7eace447.svg";